import AnnouncementBanner from "@/components/site/AnnouncementBanner";
import "./v2/theme.css";
import Hero from "@/components/site/HeroV2";

import ChaosToOrder from "@/components/site/ChaosToOrder";
import PlatformAct3 from "@/components/site/PlatformAct3";
import PartnerVoices from "@/components/site/PartnerVoices";
import Evidence from "@/components/site/Evidence";
import WhyDeepc from "@/components/site/WhyDeepcBento";

import ResultsStrip from "@/components/site/ResultsStrip";
import NetworkTeaser from "@/components/site/NetworkTeaser";
import InsightsPreview from "@/components/site/InsightsPreview";
import ClosingCTA from "@/components/site/ClosingCTA";
import Footer from "@/components/site/Footer";
import SeoHead from "@/components/SeoHead";

const Index = () => {
  return (
    <div className="theme-deepcos min-h-screen bg-background text-foreground">
      <SeoHead collectionKey="page.home" path="/" />
      <AnnouncementBanner />
      <main>
        <Hero />
        <ChaosToOrder />
        <PlatformAct3 />
        <ResultsStrip />
        <PartnerVoices />
        <Evidence />
        <WhyDeepc />
        
        
        <InsightsPreview />
        <ClosingCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
